import type { UserProfile } from "@/lib/api";

/**
 * Mirror of the backend web-login rule: staff/superusers always keep web
 * access, and a user keeps it while at least one active membership grants it.
 * Missing/unknown membership data is treated as allowed so a stale cached
 * profile can never log someone out by omission.
 *
 * Enforcement is rolled out behind the backend ENFORCE_WEB_ACCESS switch: the
 * session is only evicted when the profile reports `web_access_enforced`.
 * Until then mobile-only memberships keep the web access they have today.
 */
export function isWebAccessAllowed(user?: UserProfile | null): boolean {
  if (!user) return true;
  if (user.web_access_enforced !== true) return true;
  if (user.is_superuser || user.is_staff) return true;

  const memberships = user.organization_memberships ?? [];
  if (memberships.length === 0) return true;

  const active = memberships.filter((membership) => membership.is_active !== false);
  if (active.length === 0) return true;

  return active.some((membership) => membership.web_access !== false);
}
